// Golf 8 (0050; docs/onderzoek/golf8-samenwonen-en-ouderen.md §3.11.2): de webapp van de
// dagelijkse check-in en de familiekring (appText.care). Toon: je-vorm, rustig, volwassen; nooit
// als alarm of noodhulp. Op elke plek waar de check-in staat: "Geen bericht betekent niet altijd
// dat alles goed is" en "geen alarmdienst".
export const appCareNl = {
    nav: 'Check-in en kring',
    notForRelative: 'Deze pagina is er niet voor wie meekijkt.',
    account: 'Account',
    viaBoard: '(ja gezegd op het bord)',
    viaApp: '(ja gezegd in de app)',
    subjectLabel: 'Wie tikt er elke dag?',
    removed: '{label} is uit de kring gehaald.',
    left: 'Je bent uit de kring gestapt.',
    // Golf 8 live r1: met CHECK_IN_ENABLED uit (launch gate) bij Senior en Zorg.
    comingSoon: 'De dagelijkse check-in en de familiekring komen binnenkort. Het bord, de agenda en de herinneringen werken nu al.',
    wizardSeniorLine: 'Kijkt er later familie mee? Dat zet je aan bij Instellingen, Check-in en kring.',
    setupSaved: 'De check-in staat klaar.',
    circleOn: 'Familie laten meekijken',
    personRights: 'Rechten van {label}',
    managerSeesAll: 'Beheert het bord en ziet alles.',
    noReachSave: 'Aanzetten kan pas als iemand een seintje kan krijgen.',
    consentLaterWizard: 'De check-in start pas als {name} op het bord ja zegt.',
    title: 'Check-in en kring',
    settingsBody: "Eén grote knop 'Alles goed' op het bord, en familie die op afstand meekijkt.",
    widgetTitle: 'Dagelijkse check-in',
    setupTitle: 'Zo houden jullie contact',
    setupIntro: "Elke dag tikt {name} één keer op 'Alles goed'. Blijft dat uit, dan krijgt de familie een rustig seintje.",
    whoUsesBoard: 'Wie gebruikt het bord?',
    boardSelf: 'Ikzelf',
    boardOther: 'Iemand anders',
    otherName: 'Hoe heet die persoon?',
    otherNamePlaceholder: 'Bijvoorbeeld Mama',
    ownerHidden: 'Jij staat niet op het bord.',
    capacityQ: 'Kan {name} dit zelf beslissen?',
    capacityYes: 'Ja',
    capacityNoButton: 'Nee',
    capacityNo: 'Dan kunnen we de check-in nu nog niet aanzetten. {name} moet zelf ja kunnen zeggen. Het bord en de agenda werken gewoon.',
    checkInToggle: 'Dagelijkse check-in',
    deadline: 'Uiterlijk om',
    days: 'Op deze dagen',
    dayNames: ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'],
    grace: 'Seintje na',
    graceMin: '{n} minuten',
    whoFollows: 'Wie kijkt mee?',
    whoFollowsHint: 'Iedereen krijgt een e-mail. {name} zegt daarna zelf op het bord of het goed is.',
    inviteEmail: 'E-mailadres',
    inviteLabel: 'Hoe noemt {name} je?',
    inviteLabelOther: 'Hoe noemt {name} deze persoon?',
    addPerson: 'Nog iemand',
    rightAlerts: "Seintje als 'Alles goed' uitblijft",
    rightAgenda: 'Agenda zien (zonder privé-afspraken)',
    invite: 'Uitnodigen',
    invited: 'Uitnodiging verstuurd naar {email}',
    later: 'Later',
    disclaimerTitle: 'Geen alarmdienst',
    disclaimerBody: 'De check-in is een rustig seintje, geen alarm. Hij ziet geen val en belt geen hulp. Geen bericht betekent niet altijd dat alles goed is. Bij nood bel je 112.',
    disclaimerCheck: 'Ik begrijp dat dit geen alarmdienst is.',
    selfConsentNow: 'Omdat jij zelf het bord gebruikt, vragen we je ja hier.',
    otherConsentLater: 'Op het bord vraagt {name} de eerste keer of dit goed is. Tot dan komt er geen seintje.',
    finish: 'Klaar',
    save: 'Opslaan',
    saved: 'Opgeslagen',
    cancel: 'Annuleren',
    enable: 'Aanzetten',
    disable: 'Uitzetten',
    reachTitle: 'Wie krijgt een seintje?',
    reachOk: '{n} van {m} krijgen nu een seintje.',
    reachNone: 'Niemand krijgt nu een seintje.',
    reachNeedsInstall: '{label} moet AMUMIN eerst op het beginscherm zetten.',
    reachNoPush: '{label} heeft meldingen nog niet aangezet.',
    reachFailed: 'Het laatste seintje aan {label} kwam niet aan.',
    reachEnableFirst: 'Zet eerst meldingen aan op je telefoon. Daarna kun je de check-in aanzetten.',
    noReachInvited: 'Nog niemand kan een seintje krijgen: {names} moet de uitnodiging nog aannemen. Daarna kun je de check-in aanzetten.',
    noReachYourYes: 'Nog niemand kan een seintje krijgen: {names} wacht op jouw ja (bovenaan Vandaag). Daarna kun je de check-in aanzetten.',
    noReachTheirYes: 'Nog niemand kan een seintje krijgen: {names} wacht op het ja van {name} op het bord.',
    noReachPush: 'Nog niemand kan een seintje krijgen: {names} moet eerst meldingen aanzetten. Daarna kun je de check-in aanzetten.',
    noReachSelf: 'Nog niemand kan een seintje krijgen. Nodig iemand uit die meekijkt; die neemt de uitnodiging aan en zet meldingen aan.',
    pendingOnTitle: 'De check-in staat nog uit',
    pendingOnReady: 'Nu kan er iemand een seintje krijgen ({n} van {m}). Je kunt de check-in aanzetten.',
    pendingOnButton: 'Check-in aanzetten',
    pendingOnDone: 'De check-in staat aan.',
    pushEnable: 'Meldingen op deze telefoon aanzetten voor het huis van {name}',
    pushOpen: 'Meldingen instellen',
    iosInstall: "Op een iPhone: tik op Delen, dan 'Zet op beginscherm', en open AMUMIN vanaf daar.",
    waitConsent: 'Wacht op het ja van {name} op het bord.',
    declined: '{name} zei liever niet. Je kunt het na {date} opnieuw vragen.',
    askAgain: 'Opnieuw vragen op het bord',
    activeSince: 'Aan sinds {date}',
    stoppedGone: '{name} staat niet meer in dit huishouden. De check-in staat uit.',
    stoppedBySelf: '{name} heeft de check-in zelf uitgezet. Je kunt het opnieuw laten vragen.',
    orphanTitle: 'Je hoort bij geen huis meer',
    orphanBody: 'Je kijkt nergens meer mee en je bent geen lid van een huishouden. Je account blijft bestaan tot je het zelf verwijdert.',
    orphanAccount: 'Account',
    orphanLogout: 'Uitloggen',
    stateDone: "{name} tikte 'Alles goed' om {time}.",
    stateWaiting: 'Nog niet. Uiterlijk {time}.',
    stateDue: 'Nog niet. {name} kan nog tikken.',
    stateMissing: "Nog geen 'Alles goed' van {name} vandaag.",
    stateMissingEarlier: "Gisteren ({date}) kwam er geen 'Alles goed' van {name}.",
    stateBoardOffline: 'Het bord is offline sinds {time}, dus {name} kan misschien niet tikken.',
    stateNoBoard: 'Er is geen bord gekoppeld.',
    stateResolved: 'Toch in orde: {name} tikte om {time}.',
    stateResolvedOffline: 'Toch in orde: {name} tikte om {time} (het bord was offline).',
    stateResolvedManual: '{label}: het is in orde ({time}).',
    stateNotChecked: 'Vandaag konden we niet controleren (storing bij AMUMIN). Kijk zelf even hoe het gaat.',
    stateDegraded: 'We controleren nu even niet (storing).',
    statePaused: 'Pauze tot en met {date} (gezet door {label}).',
    stateOff: 'De check-in staat uit.',
    stateNotToday: 'Vandaag is er geen check-in.',
    stateConsentNeeded: 'Wacht op het ja van {name} op het bord.',
    stateDeclined: '{name} zei liever niet.',
    silenceNote: 'Geen bericht betekent niet altijd dat alles goed is.',
    emergencyNote: 'Geen alarmdienst. Bij nood: 112.',
    ack: 'Ik bel even',
    acked: '{label} belt even ({time})',
    ackStale: '{label} belt sinds {time}, nog niet bevestigd.',
    resolve: 'Het is in orde',
    tzNote: '(tijd bij {name})',
    history: 'Laatste {n} dagen',
    historyKinds: {
        done: 'Alles goed',
        late: 'Later getikt',
        missing: 'Geen tik',
        paused: 'Pauze',
        not_checked: 'Niet gecontroleerd',
        off: 'Geen check-in',
    },
    pauses: 'Pauzes',
    pauseAdd: 'Pauze toevoegen',
    pauseFrom: 'Van',
    pauseTo: 'Tot en met',
    pauseMax: 'Maximaal {n} dagen. Langer weg? Zet de check-in dan uit.',
    inviteInUse: 'Dit adres heeft al een uitnodiging als huisgenoot. Trek die eerst in.',
    pauseLimit: 'Een meekijker kan samen hooguit {n} dagen pauze zetten, en niet verder dan {n} dagen vooruit.',
    someone: 'iemand',
    pauseHint: 'Bijvoorbeeld op vakantie of logeren. We bewaren geen reden.',
    pauseLine: '{from} tot en met {to} (gezet door {label})',
    pauseStop: 'Pauze stoppen',
    pauseNone: 'Geen pauze gepland.',
    offlineTitle: 'Wat als het bord offline is?',
    offlineHelp: 'Heeft het bord geen verbinding, dan gaat een tik later mee. {name} kan ook de app op de telefoon gebruiken.',
    outageTitle: 'Wat als AMUMIN een storing heeft?',
    outageHelp: "Heeft AMUMIN een storing, dan zie je hier 'Vandaag niet gecontroleerd'. Geen bericht is geen bewijs dat alles goed is.",
    circleTitle: 'Kring',
    circleEmpty: 'Nog niemand kijkt mee.',
    circleStatusInvited: 'Uitgenodigd',
    circleStatusPending: 'Wacht op ja van {name}',
    circleStatusActive: 'Actief',
    circleStatusDeclined: 'Liever niet',
    roleRelative: 'Meekijker',
    roleManager: 'Beheerder',
    remove: 'Uit de kring halen',
    removeConfirm: '{label} uit de kring halen? {label} ziet daarna meteen niets meer.',
    removePauseNote: '{label} zette een pauze tot en met {date}. Die pauze stopt als je {label} weghaalt.',
    leave: 'Uit de kring stappen',
    leaveConfirm: 'Uit de kring stappen? Je ziet daarna niets meer van het huis van {name}.',
    resend: 'Opnieuw sturen',
    rightsNeedYes: 'Meer rechten? Dan vraagt het bord {name} eerst om ja.',
    newWatcher: '{label} kijkt nu mee: {rights}.',
    inviteSomeone: 'Iemand uitnodigen',
    seniorNoCircle: 'Er is nog niemand die een seintje kan krijgen.',
    switchToCare: "Wordt 'Thuis met familie die meekijkt'",
    selfButton: 'Alles goed',
    selfConsentIntro: 'Lees dit rustig. Jij beslist.',
    selfWithdraw: 'Stoppen met de check-in',
    approveTitle: '{label} wil meekijken',
    approveYes: 'Ja, dat is goed',
    approveNo: 'Liever niet',
    myCircleTitle: 'Mijn kring',
    myRights: 'Wat je ziet in het huis van {name}',
    myRightsNone: 'Je ziet nog niets: {name} zegt eerst zelf ja op het bord.',
    pushCheckIn: 'Dagelijkse check-in',
    pushCheckInQuiet: 'Ook tijdens stille uren (anders komt het seintje als je stille uren voorbij zijn)',
    inviteTitle: 'Uitnodiging om mee te kijken',
    inviteBody: '{inviter} nodigt je uit om mee te kijken bij {household}, als "{label}".',
    inviteRights: 'Je mag:',
    inviteAcceptExisting: 'Accepteren',
    inviteLoginFirst: 'Log eerst in met {email}, en open de link daarna opnieuw.',
    inviteAcceptNew: 'Account maken en accepteren',
    invitePassword: 'Kies een wachtwoord',
    inviteWrongEmail: 'Deze uitnodiging is voor een ander e-mailadres.',
    inviteInvalid: 'Deze uitnodiging is ongeldig of verlopen.',
    inviteAccepted: 'Gelukt. Op het bord wordt eerst gevraagd of het goed is. Daarna zie je het hier.',
    inviteToApp: 'Naar de app',
    notEmergencyShort: 'Dit is geen alarmdienst.',
    errorGeneric: 'Dat lukte niet. Probeer het nog eens.',
};
//# sourceMappingURL=careApp.nl.js.map